module.exports = __webpack_public_path__ + "img/66.48794a22.jpg";